import { Markierung } from '@/domain/termine/components';
import { markierungMapper } from '@/domain/termine/shared/types';
import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { formatDateTimeRange } from '@/domain/termine/shared/utils/formatDateTime';

export function SchichtInfo({ schicht }: { schicht: Schichten }) {
  return (
    <div className="flex flex-col flex-1 min-w-0">
      <span className="text-neutrals-900 text-sm">{schicht.name}</span>
      <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
        {schicht.markierung && (
          <Markierung color={markierungMapper[schicht.markierung].base} />
        )}
        {schicht.arbeitsbereich.name} ⋅{' '}
        {formatDateTimeRange(schicht.datum, schicht.beginn, schicht.ende)}
      </div>
    </div>
  );
}
